import { Injectable } from '@angular/core';
import { QuestionBase } from '@app/core/models/question/question-base';
import { DropdownQuestion } from '@app/core/models/question/dropdown-question';
import { TextboxQuestion } from '@app/core/models/question/textbox-question';
import { RadioQuestion } from '@app/core/models/question/radio-question';
import { CheckboxQuestion } from '@app/core/models/question/checkbox-question';
import { DROPDOWN, TEXTBOX, RADIO } from '@app/core/constants';
import { SliderQuestion } from '@app/core/models/question/slider-question';
import { GaugeChartQuestion } from '@app/core/models/question/gauge-chart-question';
import { AreaChartQuestion } from '@app/core/models/question/area-chart-question';

@Injectable()
export class QuestionService {
  getQuestions() {
    const questions: QuestionBase<any>[] = [
      new DropdownQuestion({
        key: 'brave',
        label: 'Bravery rating',
        options: [
          { key: 'solid', value: 'Solid' },
          { key: 'great', value: 'Great' },
          { key: 'good', value: 'Good' },
        ],
        order: 3
      }),
      new TextboxQuestion({
        key: 'firstname',
        label: 'First Name',
        value: 'Antony',
        required: true,
        order: 1
      }),
      new TextboxQuestion({
        key: 'email',
        label: 'Email',
        type: 'email',
        required: true,
        order: 2,
        icon: 'icon-kyc icon-ic_angle_down'
      }),
    ];

    return questions.sort((a, b) => a.order - b.order);
  }


  buildCoverageQuestionaire(questionRaws) {
    const questionBases: QuestionBase<any>[] = [];

    questionRaws.forEach(question => {
      if (question.controlType === DROPDOWN) {
        questionBases.push(new DropdownQuestion({
          key: question.key,
          label: question.label,
          value: question.value,
          order: question.order,
          required: question.required,
          options: question.options,
          dependsOn: question.dependsOn
        }));
      } else {
        questionBases.push(new TextboxQuestion({
          key: question.key,
          label: question.label,
          value: question.value,
          order: question.order,
          type: question.type,
          required: question.required,
          dependsOn: question.dependsOn
        }));
      }
    });

    return questionBases.sort((a, b) => a.order - b.order);
  }

  buildProfileQuestionnaire(questionRaws) {
    const questions: QuestionBase<any>[] = [];

    questionRaws.forEach(question => {
      if (question.controlType === TEXTBOX) {
        questions.push(new TextboxQuestion({
          key: question.key,
          label: question.label,
          order: question.order,
          required: question.required,
          controlType: question.controlType,
          type: question.type,
          dependsOn: question.dependsOn
        }));
      } else if (question.controlType === RADIO) {
        questions.push(new RadioQuestion({
          key: question.key,
          label: question.label,
          order: question.order,
          required: question.required,
          controlType: question.controlType,
          type: question.type,
          className: question.className,
          value: question.value,
          options: question.options,
          dependsOn: question.dependsOn
        }));
      } else {
        questions.push(new CheckboxQuestion({
          key: question.key,
          label: question.label,
          order: question.order,
          required: question.required,
          controlType: question.controlType,
          type: question.type,
          options: question.options,
          dependsOn: question.dependsOn
        }));
      }
    });

    return questions.sort((a, b) => a.order - b.order);
  }

  buildNeedsQuestionaire(questionRaws) {
    const questionBases: QuestionBase<any>[] = [];

    questionRaws.forEach(question => {
      if (question.controlType === 'gauge-chart') {
        questionBases.push(
          new GaugeChartQuestion({
            key: question.key,
            label: question.label,
            value: question.value,
            order: question.order,
            required: question.required,
            options: question.options,
            icon: question.icon,
            dependsOn: question.dependsOn
          })
        );
      } else if (question.controlType === 'slider') {
        questionBases.push(
          new SliderQuestion({
            key: question.key,
            label: question.label,
            value: question.value,
            order: question.order,
            type: question.type,
            required: question.required,
            options: question.options,
            icon: question.icon,
            dependsOn: question.dependsOn
          })
        );
      } else if (question.controlType === 'area-chart') {
        questionBases.push(
          new AreaChartQuestion({
            key: question.key,
            label: question.label,
            order: question.order,
            required: question.required,
            options: question.options,
            dependsOn: question.dependsOn
          })
        );
      }
    });

    return questionBases.sort((a, b) => a.order - b.order);
  }

  buildSaveQuestionnaire(questionRaws) {
    const questionBases: QuestionBase<any>[] = [];

    questionRaws.forEach(question => {
      if (question.controlType === 'textbox') {
        questionBases.push(
          new TextboxQuestion({
            key: question.key,
            label: question.label,
            order: question.order,
            required: question.required,
            controlType: question.controlType,
            type: question.type,
            value: question.value
        }));
      }
    });

    return questionBases.sort((a, b) => a.order - b.order);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/question.service.ts